import { DentalInsuranceReportTypes } from '@frontend/api-insurance-eligibility-report';
import { TablesDataType } from './types/types';

export const getInsuranceBenefitKeys = (summaryInfo: TablesDataType): (keyof TablesDataType)[] => {
  return Object.keys(summaryInfo).filter((key) => {
    // Check if the property type matches `DentalXChangePlanBenefitInfo[]`
    const item = summaryInfo[key as keyof TablesDataType];
    return Array.isArray(item) && item.length > 0;
  }) as (keyof TablesDataType)[];
};

const keyToTitleCase = (inputString: string): string => {
  if (!inputString) {
    return '';
  }
  if (!inputString) {
    return '';
  }

  const camelCaseToSpaces = inputString.replace(/([A-Z])/g, ' $1');
  const snakeCaseToSpaces = camelCaseToSpaces.replace(/_/g, ' ');
  return snakeCaseToSpaces.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

type AccordionListType = {
  id: keyof TablesDataType;
  label: string;
};
type GetInsuranceReportAccordionIdsReturnType = {
  accordionIds: (keyof TablesDataType)[];
  accordionList: AccordionListType[];
};
export const getInsuranceReportAccordionIds = (
  keys: (keyof TablesDataType)[]
): GetInsuranceReportAccordionIdsReturnType => {
  const accordionIds: (keyof TablesDataType)[] = [];
  const accordionList = keys.map((key) => {
    accordionIds.push(key);
    return {
      id: key,
      label: keyToTitleCase(key),
    };
  });

  return {
    accordionIds,
    accordionList,
  };
};

export const formatAdditionalInfoObjectToString = (
  additionalInformationObject: DentalInsuranceReportTypes.BenefitEntity
) => {
  let resultString = '';

  const concatenateAddress = (address: DentalInsuranceReportTypes.BenefitEntity['address']) => {
    if (!address) return '';

    const { address1, address2, city, state, zipCode } = address;
    const addressFields = [address1, address2, city, state, zipCode].filter((addressFieldData) => addressFieldData);

    return addressFields.join(', ');
  };

  // Processing address field
  const addressString = concatenateAddress(additionalInformationObject?.address);
  if (addressString) {
    resultString += `Address: ${addressString}\n`;
  }

  // Processing object fields
  if (additionalInformationObject?.entity) {
    resultString += `Entity: ${additionalInformationObject?.entity}\n`;
  }
  if (additionalInformationObject?.entityId) {
    resultString += `Entity ID: ${additionalInformationObject?.entityId}\n`;
  }
  if (additionalInformationObject?.firstName || additionalInformationObject?.lastName) {
    resultString += `Name: ${additionalInformationObject?.firstName} ${additionalInformationObject?.lastName}\n`;
  }
  if (additionalInformationObject?.benefitProvider) {
    resultString += `Benefit Provider: ${additionalInformationObject?.benefitProvider}\n`;
  }
  if (additionalInformationObject?.phone) {
    resultString += `Phone: ${additionalInformationObject?.phone}\n`;
  }

  return resultString.trim();
};
